/**
 * Prompt categories — org-global, unpaginated (capped at 200 on the backend).
 * If-Match is required on update and delete.
 */

import type {
  PromptCategoryCreate,
  PromptCategoryDeleteResponse,
  PromptCategoryListResponse,
  PromptCategoryResponse,
  PromptCategoryUpdate,
} from '@/types/prompts'
import { apiClient } from './client'
import { optionalIfMatchHeaders } from './ifMatch'

export const promptCategories = {
  list: async (): Promise<PromptCategoryListResponse> => {
    const response = await apiClient.get<PromptCategoryListResponse>(
      '/api/v1/prompt-categories/'
    )
    return response.data
  },

  create: async (
    data: PromptCategoryCreate
  ): Promise<PromptCategoryResponse> => {
    const response = await apiClient.post<PromptCategoryResponse>(
      '/api/v1/prompt-categories/',
      data
    )
    return response.data
  },

  update: async (
    id: string,
    data: PromptCategoryUpdate,
    ifMatch?: number
  ): Promise<PromptCategoryResponse> => {
    const response = await apiClient.patch<PromptCategoryResponse>(
      `/api/v1/prompt-categories/${id}/`,
      data,
      optionalIfMatchHeaders(ifMatch)
    )
    return response.data
  },

  remove: async (
    id: string,
    ifMatch?: number
  ): Promise<PromptCategoryDeleteResponse> => {
    const response = await apiClient.delete<PromptCategoryDeleteResponse>(
      `/api/v1/prompt-categories/${id}/`,
      optionalIfMatchHeaders(ifMatch)
    )
    return response.data
  },
}
